export enum ImageOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
  Square = 'square',
}
export enum ImageAspectRatio {
  FourByThree = '4:3',
  SixteenByNine = '16:9',
  OneByOne = '1:1',
}
export enum DynamicAspect {
  Auto = 'auto',
  Square = 'square',
}
